import CloseIcon from '@mui/icons-material/CloseOutlined'
import { toast, ToastBar, Toaster } from 'react-hot-toast'
import { Button } from '@mui/material'
import { toastCloseButtonSx } from '../../theme'

export const ToastProvider = () => {
	return (
		<>
			<Toaster
				position="top-right"
				reverseOrder={false}
				gutter={8}
				containerClassName=""
				containerStyle={{
					top: 56
				}}
				toastOptions={{
					className: '',
					duration: 5000,
					style: {
						background: '#000000',
						color: '#fff',
						fontFamily:
							'-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
						fontSize: '1rem'
					},
					success: {
						style: {
							background: 'green'
						}
					},
					error: {
						style: {
							background: 'red'
						}
					}
				}}
			>
				{(t) => (
					<ToastBar toast={t}>
						{({ icon, message }) => (
							<>
								{icon}
								{message}
								{t.type !== 'loading' && (
									<Button type="submit" onClick={() => toast.dismiss(t.id)} sx={toastCloseButtonSx}>
										<CloseIcon titleAccess="Dismiss" />
									</Button>
								)}
							</>
						)}
					</ToastBar>
				)}
			</Toaster>
		</>
	)
}
